// How the rep composed a message. Analytics only — it never reaches the wire.
enum ChatMessageSource {
  RETRY = "retry",
  SUGGESTION = "suggestion",
  TYPED = "typed",
  VOICE = "voice",
}

export default ChatMessageSource;
